<div class="price-change-history-card mb-3">
  <div class="card-header">
    <div class="card-title">
      <i class="fa-solid fa-clock-rotate-left" aria-hidden="true"></i>
      <span>HISTÓRICO DE ALTERAÇÕES DE PREÇO</span>
    </div>
  </div>

  <div class="card-body">
    @if (loading()) {
      <div class="loading-state">
        <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
        <span>Carregando histórico...</span>
      </div>
    } @else if (isEmpty()) {
      <div class="empty-state">
        <i class="fa-solid fa-chart-line" aria-hidden="true"></i>
        <p>Nenhuma alteração de preço registrada para esta avaliação.</p>
      </div>
    } @else {
      <div class="summary-row">
        <div class="summary-price">
          <span class="summary-label">PREÇO ATUAL</span>
          <strong class="summary-value">{{ currentPrice() | currency:'BRL':'symbol':'1.0-0' }}</strong>
        </div>

        <div class="summary-meta">
          @if (totalChangePercent() != null) {
            <span
              class="summary-badge"
              [class.summary-badge--up]="totalChangePercent()! >= 0"
              [class.summary-badge--down]="totalChangePercent()! < 0"
            >
              <i
                class="fa-solid"
                [class.fa-arrow-up]="totalChangePercent()! >= 0"
                [class.fa-arrow-down]="totalChangePercent()! < 0"
                aria-hidden="true"
              ></i>
              @if (totalChangePercent()! > 0) {+}{{ totalChangePercent()! / 100 | percent:'1.1-1' }}
            </span>
          }
          <span class="summary-count">{{ changeCount() }} alterações</span>
        </div>
      </div>

      @if (chartOptions()) {
        <div
          class="chart-wrap"
          echarts
          [options]="chartOptions()!"
          [autoResize]="true"
        ></div>
      }

      <div class="type-legend">
        <span class="legend-item">
          <i class="fa-solid fa-circle legend-icon legend-icon--default" aria-hidden="true"></i>
          Comum
        </span>
        <span class="legend-item">
          <i class="fa-solid fa-square legend-icon legend-icon--intervention" aria-hidden="true"></i>
          Intervenção
        </span>
        <span class="legend-item">
          <i class="fa-solid fa-play legend-icon legend-icon--estimate" aria-hidden="true"></i>
          Estimativa
        </span>
      </div>

      <div class="card-divider"></div>

      <div class="footer-hint">
        <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
        <span>Passe o mouse sobre os pontos para ver quem alterou e quando.</span>
      </div>

      @if (lastChange()) {
        <div class="footer-last">
          <i class="fa-solid fa-pen" aria-hidden="true"></i>
          <span>Última alteração: <strong>{{ lastChange() }}</strong></span>
        </div>
      }
    }
  </div>
</div>
